// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Format_wrapper__wgulM","radio":"Format_radio__nB8FQ","radioButton":"Format_radioButton__AtZoq","active":"Format_active__SmmIE"};